import React from 'react';
import { useTheme } from '../ThemeContext';
import './ThemeToggle.css';

const SunIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
  </svg>
);

const MoonIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

const ThemeToggle = ({ className = '', showLabels = false }) => {
  const { theme, setTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div
      className={`theme-toggle ${showLabels ? 'theme-toggle--labeled' : ''} ${className}`.trim()}
      role="group"
      aria-label="Color theme"
    >
      <button
        type="button"
        className={`theme-toggle__option ${!isDark ? 'is-active' : ''}`}
        onClick={() => setTheme('light')}
        aria-pressed={!isDark}
        aria-label="Light mode"
        title="Light mode"
      >
        <SunIcon />
        {showLabels && <span>Light</span>}
      </button>
      <button
        type="button"
        className={`theme-toggle__option ${isDark ? 'is-active' : ''}`}
        onClick={() => setTheme('dark')}
        aria-pressed={isDark}
        aria-label="Dark mode"
        title="Dark mode"
      >
        <MoonIcon />
        {showLabels && <span>Dark</span>}
      </button>
    </div>
  );
};

export default ThemeToggle;
